import { BoldPlugin, ItalicPlugin, UnderlinePlugin } from '@platejs/basic-nodes/react';

export const BasicMarksKit = [BoldPlugin, ItalicPlugin, UnderlinePlugin];
